// Utilidad para integrar el widget "Appointment Scheduling" de Google Calendar.
// Centraliza la URL y la carga del script/CSS para reutilizarlo en varias secciones.

export const GCAL_CSS = 'https://calendar.google.com/calendar/scheduling-button-script.css';
export const GCAL_SCRIPT = 'https://calendar.google.com/calendar/scheduling-button-script.js';
export const GCAL_URL =
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0kYDz0Qed9-jVydpfjrx_8tbH2vuK5C2zK4RIBjUInZD5QiAZDZ69_WJ7YcZkMEGgx022jXBu8?gv=true';

// Inyecta el CSS del widget una sola vez.
const ensureGcalStyles = () => {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.querySelector(`link[href="${GCAL_CSS}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = GCAL_CSS;
    document.head.appendChild(link);
  }
};

// Carga el script del widget (una sola vez) y resuelve cuando window.calendar está listo.
export const loadGcalScript = () =>
  new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      return reject(new Error('No window'));
    }

    ensureGcalStyles();

    if (window.calendar && window.calendar.schedulingButton) {
      return resolve(window.calendar);
    }

    const existing = document.querySelector(`script[src="${GCAL_SCRIPT}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve(window.calendar));
      existing.addEventListener('error', reject);
      // Por si el script ya cargó antes de añadir el listener.
      if (window.calendar && window.calendar.schedulingButton) {
        resolve(window.calendar);
      }
      return;
    }

    const script = document.createElement('script');
    script.src = GCAL_SCRIPT;
    script.async = true;
    script.addEventListener('load', () => resolve(window.calendar));
    script.addEventListener('error', reject);
    document.body.appendChild(script);
  });
